export class Encoding {

  minKbps: number;
  qualityLevelName: string;
  relUrl: string;

  static fromJSON(json: EncodingJSON): Encoding {
    if (json) {
      const encoding = Object.create(Encoding.prototype);
      return Object.assign(encoding, json, {});
    }
    return null;
  }

  toJSON(): EncodingJSON {
    return Object.assign({}, this, {});
  }

  constructor(public data: any) {
    const json: JSON = data;
    if (json) {
      this.minKbps = json['minKbps'];
      this.qualityLevelName = json['qualityLevelName'];
      this.relUrl = json['relUrl'];
    }
  }
}

interface EncodingJSON {
  minKbps: number;
  qualityLevelName: string;
  relUrl: string;
}



// WEBPACK FOOTER //
// ./src/app/model/encoding.ts